<template>
  <el-dialog title="新增车辆" :visible.sync="dialogVisible" width="500px" :before-close="handleCancel">
    <el-form :model="formData" :rules="rules" ref="vehicleForm" label-width="100px" label-suffix="：">
      <!-- 车牌号 -->
      <el-form-item label="车牌号" prop="licensePlateNum">
        <el-input v-model="formData.licensePlateNum" placeholder="请输入"></el-input>
      </el-form-item>

      <!-- 司机 -->
      <el-form-item label="司机" prop="name">
        <el-input v-model="formData.name" placeholder="请输入"></el-input>
      </el-form-item>

      <!-- 联系方式 -->
      <el-form-item label="联系方式" prop="tel">
        <el-input v-model="formData.tel" placeholder="请输入" maxlength="11" @input="handleTelInput"></el-input>
      </el-form-item>

      <!-- 身份证 -->
      <el-form-item label="身份证" prop="idCard">
        <el-input v-model="formData.idCard" placeholder="请输入"></el-input>
      </el-form-item>

      <!-- 实发数量 -->
      <el-form-item label="实发数量" prop="actualSendQuantity">
        <el-input-number
          label="请输入"
          v-model="formData.actualSendQuantity"
          :precision="4"
          :min="0"
          :max="999999999"
          :step="1"
          placeholder="请输入"
          style="width: 100%"
        ></el-input-number>
      </el-form-item>
    </el-form>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "VehicleFormDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        tel: "",
        name: "",
        idCard: "",
        cusBoId: "",
        licensePlateNum: "",
        actualSendQuantity: "",
      },
      rules: {
        licensePlateNum: [{ required: true, message: "请输入车牌号", trigger: "blur" }],
        name: [{ required: true, message: "请输入司机姓名", trigger: "blur" }],
        tel: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的11位手机号", trigger: "blur" },
          { len: 11, message: "手机号必须为11位", trigger: "blur" },
        ],
        actualSendQuantity: [{ required: true, message: "请输入实发数量", trigger: "blur" }],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    // 限制手机号只能输入数字
    handleTelInput(value) {
      this.formData.tel = value.replace(/\D/g, "");
    },
    handleCancel() {
      this.$refs.vehicleForm.resetFields();
      this.$emit("update:visible", false);
      this.$emit("cancel");
    },
    handleConfirm() {
      this.$refs.vehicleForm.validate((valid) => {
        if (valid) {
          // 深拷贝表单数据，避免引用问题
          const submitData = JSON.parse(JSON.stringify(this.formData));

          // 表单验证通过，提交数据
          this.$emit("confirm", submitData);

          // 提交后关闭弹框并重置表单
          this.$refs.vehicleForm.resetFields();
          this.$emit("update:visible", false);
        } else {
          this.$message.error("请填写完整信息");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
